import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import { registerResellerHost, type ResellerHost } from './host'

const Detail = lazy(() => import('./components/Detail'))
const List = lazy(() => import('./components/List'))
const New = lazy(() => import('./components/New'))

const ResellerModule: RouteObject = {
    path: 'resellers',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: 'new',
            element: <New />,
        },
        {
            path: ':id',
            element: <Detail />,
        },
    ],
}

/**
 * The Reseller route, for the host to mount (it adds the errorElement).
 *
 * This is the only way to get it, and it takes the host: so a host cannot
 * mount the route and forget to register the pieces it reads at render time.
 * Registering also adds the `reseller` i18n namespace.
 */
export function createResellerModule(host: ResellerHost): RouteObject {
    registerResellerHost(host)
    return ResellerModule
}

export type { ResellerHost } from './host'
